import React, { PureComponent } from "react";

import Album from "Common/Album";
import AlbumFetching from "Common/AlbumFetching";

import styles from "./AlbumList.local.scss";
import classnames from "classnames";
//import _ from "i18n";

export default class AlbumListComponent extends PureComponent {
  render() {
    const { fetching } = this.props;

    if (fetching) {
      return (
        <ul className={classnames(styles.list, "grid-x")}>
          {Array(8)
            .fill(1, 0, 8)
            .map(el => (
              <li
                className="cell smal-12 medium-4 large-3"
                key={`album-fetching-${Math.random() + Date.now()}`}
              >
                <AlbumFetching />
              </li>
            ))}
        </ul>
      );
    }
    const { albums } = this.props;

    return (
      <ul className={classnames(styles.list, "grid-x")}>
        {albums.map(album => (
          <li
            key={`album-item-${album.id}`}
            className="cell small-12 medium-6 large-3"
          >
            <Album album={album} />
          </li>
        ))}
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/AlbumList/AlbumListComponent.js